var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 5.96679C4.02415 5.96679 3.5 6.51252 3.5 7.06392V15.0496C3.5 15.601 4.02415 16.1467 4.8 16.1467H8.91379C9.18993 16.1467 9.41379 16.3706 9.41379 16.6467C9.41379 16.9228 9.18993 17.1467 8.91379 17.1467H4.8C3.58762 17.1467 2.5 16.2623 2.5 15.0496V7.06392C2.5 5.85118 3.58762 4.96679 4.8 4.96679H19.2C20.4124 4.96679 21.5 5.85118 21.5 7.06392V10.5631C21.5 10.8393 21.2761 11.0631 21 11.0631C20.7239 11.0631 20.5 10.8393 20.5 10.5631V7.06392C20.5 6.51252 19.9758 5.96679 19.2 5.96679H4.8Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30574 18.6467C8.30574 18.3705 8.5296 18.1467 8.80574 18.1467H10.0841C10.3602 18.1467 10.5841 18.3705 10.5841 18.6467C10.5841 18.9228 10.3602 19.1467 10.0841 19.1467H8.80574C8.5296 19.1467 8.30574 18.9228 8.30574 18.6467Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7989 16.8077L17.5758 16.2432L17.2791 15.3299L16.3188 15.3299L16.022 16.2432L16.7989 16.8077ZM14.8464 16.6252L16.7989 18.0438L18.7514 16.6252L18.0056 14.3299L15.5922 14.3299L14.8464 16.6252Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4838 13.3264L15.9709 11.8386L15.0205 11.5274L14.564 12.9218L13.0884 12.955L13.1109 13.9548L14.6787 13.9195L15.3864 14.8925L16.1951 14.3043L15.4838 13.3264Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9158 13.929L20.4805 13.9772L20.5113 12.9777L19.0448 12.9325L18.5972 11.526L17.6443 11.8293L18.1198 13.3236L17.3856 14.2768L18.1779 14.887L18.9158 13.929Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2958 18.8857L15.0194 19.792L15.5984 20.6074L16.7947 19.7579L18.0007 20.6088L18.5772 19.7917L17.2958 18.8877L17.3056 17.6845L16.3056 17.6764L16.2958 18.8857Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3767 17.3873L19.7786 18.8688L20.7437 18.607L20.365 17.2107L21.5473 16.3619L20.9641 15.5496L19.7151 16.4463L18.6272 16.0475L18.283 16.9864L19.3767 17.3873Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.221 17.3873L13.8192 18.8688L12.8541 18.607L13.2328 17.2107L12.0505 16.3619L12.6337 15.5496L13.8827 16.4463L14.9706 16.0475L15.3148 16.9864L14.221 17.3873Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7989 20.1586C19.1187 20.1586 20.9993 18.278 20.9993 15.9582C20.9993 13.6384 19.1187 11.7578 16.7989 11.7578C14.4791 11.7578 12.5985 13.6384 12.5985 15.9582C12.5985 18.278 14.4791 20.1586 16.7989 20.1586ZM16.7989 21.1586C19.671 21.1586 21.9993 18.8303 21.9993 15.9582C21.9993 13.0861 19.671 10.7578 16.7989 10.7578C13.9268 10.7578 11.5985 13.0861 11.5985 15.9582C11.5985 18.8303 13.9268 21.1586 16.7989 21.1586Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportBar);
export default __webpack_public_path__ + "static/media/sport_bar.8b809a92beb2128d0a649cbd628b2676.svg";
export { ForwardRef as ReactComponent };